import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { formatClock } from '../../lib/formatters/time';
import { testChannelDelivery } from '../../lib/api/channels';

// Cutover §3 honesty: the console does NOT simulate deliveries. Send calls
// the real backend stub (POST /api/channels/:id/test-send), which answers
// 501 until a channel transport exists (dry-run gate, §5). The result line
// renders the refusal — a real round-trip with an honest no, replacing the
// old 700ms fake "delivered" timer.
function TestMessageConsole({ channel, channels, onChannelChange }) {
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const disabled = !channel || channel.status === 'offline' || sending;

  const handleSend = async (domEvent) => {
    domEvent.preventDefault();
    if (disabled) return;

    setSending(true);
    setResult(null);

    try {
      await testChannelDelivery(channel.id, {
        message: body.trim() || 'Test message from Channels Hub'
      });
      // The stub must refuse while no transport exists; a 2xx would mean the
      // contract changed underneath us — surface it, never fake success.
      setResult({ kind: 'failed', detail: 'Unexpected success — transport state changed' });
    } catch (sendError) {
      // apiFetch throws "API request failed: 501" — the honest refusal.
      setResult({
        kind: 'notlive',
        detail: 'Not live yet — no external messages can be sent (dry-run round)'
      });
    }

    setSending(false);
    setBody('');
  };

  return (
    <form className="test-console" onSubmit={handleSend}>
      <div className="test-console__row">
        <select
          aria-label="Channel under test"
          onChange={(domEvent) => onChannelChange(domEvent.target.value)}
          value={channel?.id ?? ''}
        >
          <option value="" disabled>Select a channel…</option>
          {channels.map((candidate) => (
            <option key={candidate.id} value={candidate.id}>
              {candidate.name} — {candidate.status ?? 'unknown'}
            </option>
          ))}
        </select>
        <input
          onChange={(domEvent) => setBody(domEvent.target.value)}
          placeholder="Message body (optional)…"
          type="text"
          value={body}
        />
        <button className="primary-button" disabled={disabled} type="submit">
          <FiIcons.FiSend /> {sending ? 'Sending…' : 'Send test'}
        </button>
      </div>
      <p className="test-console__hint">
        {channel?.handle
          ? <span>Destination: <code>{channel.handle}</code></span>
          : <span>No channel selected</span>}
        {result && (
          <span
            className={`test-console__result test-console__result--${result.kind}`}
            role="status"
          >
            {' '}· {result.detail} ({formatClock(Date.now())})
          </span>
        )}
      </p>
    </form>
  );
}

export default TestMessageConsole;
